import { Tabs, TabsProps } from '@mui/material';
import React from 'react';

export default function CustomTabs(props: TabsProps) {
  return (
    <Tabs
      {...props}
      sx={{
        'flexDirection': 'column',
        'position': 'relative',
        '&:before': {
          display: 'block',
          content: '""',
          height: '1px',
          bgcolor: 'custom.separatorLine',
          width: 1,
          position: 'absolute',
          bottom: 0,
        },
        ...props.sx,
      }}
    ></Tabs>
  );
}
